import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async () => {
    const { data } = await ApiService.getDspInventorySourceDeals();
    return data;
};

const useDspInventorySourceDealListQuery = () => {
    return useQuery({
        queryKey: ['dspInventorySourceDealList'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: false,
    });
};

export { useDspInventorySourceDealListQuery };
